import { connect } from 'react-redux'

import { setAuthorizedUserAction, selectAction } from './actions'
import AuthComponent from './AuthComponent'

const mapStateToProps = state => {
  return {
  	authorizedUser: state.authorizedUser,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setAuthorizedUser: (user) => dispatch(setAuthorizedUserAction(user)),
    onSelectClick: (selected) => dispatch(selectAction(selected)),
  }
}

const AuthContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AuthComponent)

export default AuthContainer



// WEBPACK FOOTER //
// ./src/AuthContainer.js